<template>
  <div>
    <b-row>
      <b-col md="6" class="my-1">
        <h3 class="text-themecolor">{{$t('datatables.bedrijven')}}</h3>
      </b-col>
      <b-col md="6" class="my-1">
        <div class="pull-right">
          <b-button variant="themecolor" size="sm" @click="goTo('create')" class="mr-1">
            <i class="fa fa-plus" aria-hidden="true"></i> {{$t('buttons.toevoegen')}}
          </b-button>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        <div class="card">
          <div class="card-body">
            <!-- User Interface controls -->
            <b-row>
              <b-col md="12" class="my-1">
                <b-form-group class="mb-0">
                  <b-input-group>
                    <b-form-input v-model="filter" :placeholder="$t('datatables.zoeken')" ref='search' />
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <!-- User Interface controls -->

            <!-- Main table element -->
            <b-row>
              <b-col md="12">
                <b-table show-empty
                        stacked="md"
                        :empty-text="getEmptyText(count)"
                        class="table-hover"
                        :items="companies"
                        :fields="fields"
                        :current-page="currentPage"
                        :per-page="perPage"
                        :filter="filter"
                        @filtered="onFiltered"
                        @row-clicked="onRowClicked"
                        :busy="count == -1">
                        <template v-slot:cell(active)="row">{{row.value ? $t('releases.ja') : $t('releases.nee')}}</template>
                        <template v-slot:table-busy>
                          <PreLoader/>
                        </template>
                </b-table>
              </b-col>
            </b-row>
            <!-- Main table element -->

            <!-- Pagination controls -->
            <b-row>
              <b-col md="12" lg="5" >
                <b-form-group label-cols :label="$t('datatables.perpagina')">
                  <b-form-select :options="pageOptions" v-model="perPage" />
                </b-form-group>
              </b-col>
              <b-col md="12" lg="7">
                <b-pagination :total-rows="count" :per-page="perPage" v-model="currentPage" class="my-0 pull-right" />
              </b-col>
            </b-row>
            <!-- Pagination controls -->
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>
<script>
//Import store
import { mapGetters, mapActions } from 'vuex'
import PreLoader from '@/components/root/Preloader';
import { getEmptyText } from '@/views/root/GetMessageTextHelper';

export default {
  name: 'companies-index',
  components: {PreLoader},
  data () {
    return {
      currentPage: 1,
      perPage: 50,
      pageOptions: [ 50, 100, 200 ],
      filter: null,
      count: -1
    }
  },
  computed: {
    fields() {
      return [
        { key: 'name', label: this.$i18n.t('datatables.naam'), sortable: true },
        { key: 'domainName', label: this.$i18n.t('datatables.domeinnaam'), sortable: true },
        { key: 'active', label: this.$i18n.t('datatables.actief') },
      ]
    },
    ...mapGetters ('management', ['companies']),
    sortOptions () {
      return this.fields.filter(f => f.sortable).map(f => { return { text: f.label, value: f.key } })
    }
  },
  methods: {
    ...mapActions('management',['all']),
    onFiltered (filteredItems) {
      this.count = filteredItems.length;
      this.currentPage = 1
    },
    onRowClicked(item) {
      this.$router.push({ name: `companies:detail`, params: { companyId: item.id } });
    },
    goTo(name) {
      this.$router.push({ name: `companies:${name}` });
    },
    getEmptyText,
  },
  watch: {
    companies: function(value) {
      this.count = value.length;
    }
  },
  created() {
    var vm = this;
    vm.all({
      resource: 'companies'
    });
  }
}
</script>